import { newarkConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function NewarkPage() {
  return <CityPageTemplate config={newarkConfig} />;
}